/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M27.195 23.996l5.648-5.648a.573.573 0 0 0 0-.806l-2.383-2.383a.572.572 0 0 0-.805 0l-5.649 5.649-5.653-5.652a.572.572 0 0 0-.805 0l-2.383 2.384a.571.571 0 0 0 0 .806l5.652 5.651-5.65 5.65a.573.573 0 0 0 0 .805l2.383 2.383c.222.22.586.22.806 0l5.649-5.649 5.646 5.647a.573.573 0 0 0 .806 0l2.384-2.384a.575.575 0 0 0 0-.806l-5.646-5.647z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/close.js